
import { manageUpdateAccessObj } from "../../features/manageUpdateAccess/manageUpdateAccessTypes";
import { fetchNewUpdateAccessConfig, fetchUpdateAccessConfig } from "../../services/manageUpdateAccessService";
import { EnvironmentRegistry } from "../../services/registry/environmentRegistry";
import { requestType } from "../../types";
import store from "../store";


export async function validateWithOtp(onSuccess:(verifiedUser?: manageUpdateAccessObj,verifyResponse?: any)=>void,enabledEnvironments: string[] = ["demo","prod","prod-egtm"],allowedUsersType?: "all" | "admin",api?:string,apiPayload?:any, verifyType?: requestType,newUI?:boolean){
    const curEnvironment = EnvironmentRegistry.getEnvironment();
    if((api && verifyType) || enabledEnvironments.includes(curEnvironment as string)){
      const updateAccessConfig = await fetchUpdateAccessConfig(
        "update_access_configuration"
      );
      // const updateAccessConfig = await fetchNewUpdateAccessConfig(
      //   "update_access_configuration"
      // );
      if(!updateAccessConfig){
          onSuccess();
          return;
      }
      let allowedUsers = [];
        if (allowedUsersType === "admin") {
          allowedUsers = updateAccessConfig[0]?.value.filter(
            (user: manageUpdateAccessObj) => {
              return user.isAdmin;
            }
          );
        } else {
          allowedUsers = updateAccessConfig[0].value;
        }
        allowedUsers = allowedUsers && allowedUsers.map((user: manageUpdateAccessObj) => {
          const phNumberWithoutSpaces = user.phoneNumber.replace(/\s/g, "");
          return {
            ...user,
            phoneNumber: phNumberWithoutSpaces
          }
        })
      if(allowedUsers.length>0){
      // if(allowedUsers.length>0 && (EnvironmentRegistry.getEnvironment()=='prod' || EnvironmentRegistry.getEnvironment()=='prod-egtm') ){
          store.dispatch({
              type: "setOtpPopupState",
              payload: {
                  isOpen:true,
                  allowedUsers,
                  onSuccess:onSuccess,
                  api,
                  apiPayload,
                  verifyType,
                  newUI:newUI
              }
          })
      }else{
          onSuccess();
          return;
      }
    }else{
      onSuccess();
      return;
    }
    
}
export function closeOtpPopup(){
    store.dispatch({
        type: "closeOtpPopup",
        payload:{}
    })
}